import { useEffect } from "react";

import Notice from "@buildpy/ui/notice";
import { Button } from "@buildpy/ui/button";

/**
 * 앱 화면의 마지막 그물. 여기까지 온 예외는 이미 화면 하나를 날린 뒤이므로
 * 「무엇이 날아갔는지」 를 말해 주고 되돌아갈 길만 준다 — 스택은 보여 주지 않는다.
 */
const AppError = ({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) => {
  useEffect(() => {
    // 서버 로그로 남긴다. 사용자에게는 digest 만 보인다.
    console.error(error);
  }, [error]);

  return (
    <Notice
      actions={
        <>
          <Button size="sm" variant="primary" onClick={reset}>
            다시 시도
          </Button>
          <Button asChild size="sm" variant="outline">
            <a href="/app">홈으로</a>
          </Button>
        </>
      }
      body="잠시 뒤에 다시 시도해 주세요. 같은 화면에서 계속 나면 방금 무엇을 하고 있었는지와 함께 알려 주세요."
      className="max-w-md"
      title="화면을 그리지 못했습니다">
      {error.digest && (
        <p className="mt-2 text-xs tabular-nums text-muted-foreground">
          오류 번호 {error.digest}
        </p>
      )}
    </Notice>
  );
};

export default AppError;
